<template>
  <v-expansion-panels v-model="subscriptionsPanel">
    <v-expansion-panel>
      <v-expansion-panel-header class="text-h6 font-weight-regular">
        <v-row>
          <v-col md="auto">
            {{ $t('SUBSCRIPTIONS.ITEMS') }}
          </v-col>
          <v-spacer />
          <v-col v-if="$can('sensitive-data')" md="auto">
            <v-btn class="mr-4" outlined color="indigo" @click.stop="create">
              <v-icon left>mdi-plus</v-icon>
              {{ $t('ITEM.NEW') }} {{ $t('SUBSCRIPTIONS.ITEM') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <subscriptions-list
          :type="type"
          :meta="meta"
          :items="subscriptions"
          :options.sync="options"
          @show="show"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="600"
    >
      <component
        :is="component.name"
        v-bind="component.data"
        @created="cancelDialogAndRefresh"
        @updated="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      />
    </v-dialog>
  </v-expansion-panels>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import DataOptions from '@/modules/_global/classes/DataOptions';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { SubscriptionsService } from '@/services/subscriptions.service';
import { PERSON } from '@/modules/subscriptions/components/SubscriptionsList.vue';

export default {
  name: 'PersonSubscriptionsList',

  components: {
    SubscriptionsList: () =>
      import('@/modules/subscriptions/components/SubscriptionsList'),
    CreateSubscription: () =>
      import('@/modules/persons/components/Subscriptions/CreateSubscription'),
    EditSubscription: () =>
      import('@/modules/subscriptions/components/EditSubscription')
  },

  mixins: [errors, i18nRefreshData],

  model: {
    prop: 'person'
  },

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      type: PERSON,
      subscriptions: [],
      meta: {
        total: 0
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['to'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      error: null,
      dialog: false,
      component: null,
      subscriptionsPanel: undefined
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    }
  },

  watch: {
    options: {
      handler() {
        this.refreshData();
      },
      deep: true
    }
  },

  mounted() {
    this.getSubscriptions().then(() => {
      if (this.meta.total) {
        this.openPanel();
      }
    });
  },

  methods: {
    refreshData() {
      this.openPanel();
      this.getSubscriptions();
    },

    getSubscriptions() {
      return SubscriptionsService.getList({
        ...this.preparedOptions,
        person: this.personId
      })
        .then(({ data: { meta, data } }) => {
          this.meta = meta;
          this.subscriptions = data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    create() {
      this.dialog = true;
      this.component = {
        name: 'CreateSubscription',
        data: {
          personId: this.personId
        }
      };
    },

    show(subscription) {
      this.dialog = true;
      this.component = {
        name: 'EditSubscription',
        data: {
          id: subscription.id,
          personId: this.personId
        }
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    },

    openPanel() {
      this.subscriptionsPanel = 0;
    }
  }
};
</script>

<style scoped></style>
